import { render, staticRenderFns } from "./DefaultSideBar.vue?vue&type=template&id=78101f1a&scoped=true&"
import script from "./DefaultSideBar.vue?vue&type=script&lang=js&"
export * from "./DefaultSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSideBar.vue?vue&type=style&index=0&id=78101f1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78101f1a",
  null
  
)

export default component.exports